import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { ILocation } from '../../../../../../shared/interfaces/ILocation';
import type { PersonDetail } from '../../../../../../shared/interfaces/person-detail.interface';

@Component({
    selector: 'app-tab-person-detail',
    templateUrl: './tab-person-detail.component.html',
    styleUrls: ['./tab-person-detail.component.scss'],
    imports: [TranslatePipe]
})
export class TabPersonDetailComponent {
    public readonly location = input.required<ILocation>();
    public readonly userDetail = input.required<PersonDetail>();
}
